// rules for field validation
export default function ruleUtils() {
  const { t } = useI18n();
  const allRules = {
    requiredRule: (fieldName) => {
      return [(v) => !!v || t('forms.validation.requiredField', {fieldName: fieldName})];
    },

    emailRule: [
      (v) => !!v || t("forms.validation.emailRequired"),
      (v) => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || t("forms.validation.emailValid");
      },
    ],
  };

  /**
   * returns list of rules
   * @param {[string]} rules - list of rules to get
   */
  const getRules = (rules) => {
    return Object.keys(allRules)
      .filter((key) => rules.includes(key))
      .reduce(
        (filteredRules, key) => (
          (filteredRules[key] = allRules[key]), filteredRules
        ),
        {}
      );
  };

  return {
    allRules,
    getRules,
  };
}
